<script>
import { Doughnut } from 'vue-chartjs'

export default {
  name: 'DoughnutChart',
  extends: Doughnut,

  props: {
    chart: null
  },

  data () {
    return {
      datasets: [],
      labels: []
    }
  },

  methods: {
    createChart () {
      this.addColors()
      this.renderChart({
        labels: this.labels,
        datasets: this.datasets
      }, {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom',
          display: !this.disableLegend,
          labels: {
            generateLabels: function(chart){
              var labels = this.labels.map(function(label){
                var index = this.labels.indexOf(label)
                var value = this.datasets[0].data[index]
                var color = this.datasets[0].backgroundColor[index]
                var meta = chart.getDatasetMeta(0)
                var text = label + ': ' + value
                if ( this.useDoughnutPercentages ) {
                  text += '%'
                }
                return {
                  text: text,
                  index: index,
                  fillStyle: color,
                  hidden: isNaN(this.datasets[0].data[index]) || meta.data[index].hidden,
                }
              }.bind(this))
              return labels
            }.bind(this)
          }
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: function(tooltipItem, data) {
              var label = this.labels[tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']]
              if ( this.useDoughnutPercentages ) {
                label += '%'
              }
              return label
            }.bind(this)
          }
        }
      })
    },

    addColors () {
      this.datasets.forEach(function(dataset){
        dataset.backgroundColor = this.$defaultColors
      }.bind(this))
    }
  }

}
</script>
